import urls from '@/legacy/config/env';
import { fetchRequest } from '@/legacy/services';
import { Option } from '@/legacy/types';

import { buildQueryString } from '@/shared/utils/buildQueryString';

import {
	DelegationOptionsParams,
	mapDelegationOptionsParamsToApi,
} from '../mappers/delegationOptions';

export const fetchDelegationOptions = async (
	params?: DelegationOptionsParams,
): Promise<Option[]> => {
	const apiParams = mapDelegationOptionsParamsToApi(params);
	const qs = buildQueryString(apiParams ?? {});
	const url = qs ? `${urls.formOptions.delegations}?${qs}` : urls.formOptions.delegations;

	const response = await fetchRequest<Option[]>({
		url,
		method: 'GET',
	});

	return response.data;
};
